import { Phone, AtSign, ChevronRight, Landmark, Users } from "lucide-react";
import Link from "next/link";
import React from "react";
export interface ButtonData {
  label: string;
  href?: string;
  onClick?: () => void;
  icon: React.ReactNode;
}
interface ContactButtonsProps {
  buttons: ButtonData[];
}
export const ContactButtons: React.FC<ContactButtonsProps> = ({
  buttons
}) => {
  const buttonBaseClass = "inline-flex h-10 w-full items-center justify-between gap-3 rounded-3xl px-5 py-6 text-sm font-medium text-glow/90 ring-offset-background transition duration-200 ease-linear hover:bg-glow/30 hover:text-glow focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-glow/20 shadow-md hover:shadow-sm active:scale-95";
  return <>
      {buttons.map((btn, index) => <React.Fragment key={index}>
          {btn.href ? <Link className={buttonBaseClass} href={btn.href} rel="noopener noreferrer" target="_blank">
              <div className="flex items-center gap-2 text-start">
                {btn.icon}
                {btn.label}
              </div>
              <ChevronRight size={20} />
            </Link> : <button className={buttonBaseClass} onClick={btn.onClick}>
              <div className="flex items-center gap-2 text-start">
                {btn.icon}
                {btn.label}
              </div>
              <ChevronRight size={20} />
            </button>}
        </React.Fragment>)}
    </>;
};
export default ContactButtons;